import { render } from "./TrustedDevices.vue?vue&type=template&id=35fe07d4&ts=true"
import script from "./TrustedDevices.vue?vue&type=script&lang=ts"
export * from "./TrustedDevices.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__